import reducer from "./storySlice";

export default reducer;
